<!--
 * @FilePath: Search.vue
 * @Author: Aron
 * @Date: 2023-07-18 09:51:32
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2024-07-17 10:54:25
 * Copyright: 2023 xxxTech CO.,LTD. All Rights Reserved.
 * @Descripttion:
-->
<template>
  <div class="search-module">
    <div class="title-heading" v-if="title">
      <span>{{ title }}</span>
    </div>
    <!-- 搜索 -->
    <el-form class="search-block" ref="searchFormRef" :model="formModel" :inline="inline" :rules="rules" @submit.native.prevent>
      <el-row>
        <!-- 一个大对象里面有多个小对象 -->
        <el-col :xs="18" :sm="12" :md="12" :lg="7" :xl="5" v-for="(item, key) in searchGroupForm.group1" :key="key">
          <!-- 最外层就有 prop，所以可以保证必填 -->
          <el-form-item :prop="key" :class="[item.class, flagSty && item.flag == 'refreshDom' ? 'refreshDom' : '']"
            :ref="key">
            <template slot="label">
              <div style="display:inline-block;direction: rtl">
                :
                {{ (item.label || '').replace(":", "").replace("：", "") }}
              </div>
            </template>
            <template v-if="item.component === 'slot'">
              <slot :name="item.slot"></slot>
            </template>
            <template v-if="item.component === 'el-date-picker' && item.customContent">
              <DatePicker :item="item" @change="(beginTime, endTime) =>
                changeDate(item.attrs.name, beginTime, endTime, key)
                " v-model="formModel[key]" ref="datePicker"></DatePicker>
            </template>
            <template v-if="item.component === 'el-tree' && item.customContent">
              <div class="search-tree-with-suffix">
                <div class="search-tree-with-suffix__main">
                  <IntroduceTree @select="data => selectTree(key, data)" v-if="item.attrs.treeType === 'introduce'"
                    :inputPlaceholder="item.attrs.placeholder" :doClear="doClearFlag" v-model="formModel[key]">
                  </IntroduceTree>
                  <CustomTree @select="data => selectTree(key, data)" v-if="item.attrs.treeType === 'custom'"
                    :inputPlaceholder="item.attrs.placeholder" :doClear="doClearFlag" v-model="formModel[key]">
                  </CustomTree>
                  <UserTree @select="data => selectTree(key, data, item)" v-if="!item.attrs.treeType"
                    :inputPlaceholder="item.attrs.placeholder" :doClear="doClearFlag" v-model="formModel[key]">
                  </UserTree>
                  <ExtendZtree @select="data => selectTree(key, data)" v-if="item.attrs.treeType === 'extend'"
                    :inputPlaceholder="item.attrs.placeholder" :doClear="doClearFlag" v-model="formModel[key]">
                  </ExtendZtree>
                  <DistributorTree @select="data => selectTree(key, data)" v-if="item.attrs.treeType === 'distributor'"
                    :inputPlaceholder="item.attrs.placeholder" :doClear="doClearFlag" v-model="formModel[key]">
                  </DistributorTree>
                  <GoodsTree @select="data => selectTree(key, data)" v-if="item.attrs.treeType === 'goods'"
                    :inputPlaceholder="item.attrs.placeholder" :doClear="doClearFlag" v-model="formModel[key]">
                  </GoodsTree>
                  <WarehouseTree @select="data => selectTree(key, data)" v-if="item.attrs.treeType === 'warehouse'"
                    :inputPlaceholder="item.attrs.placeholder" :doClear="doClearFlag" v-model="formModel[key]">
                  </WarehouseTree>
                  <SubAgentTree @select="data => selectTree(key, data)" v-if="item.attrs.treeType === 'agent'"
                    :inputPlaceholder="item.attrs.placeholder" :doClear="doClearFlag" v-model="formModel[key]"
                    :labelId="labelId">
                  </SubAgentTree>
                  <SubAgentTreeV3 @select="data => selectTree(key, data)" v-if="item.attrs.treeType === 'agentV3'"
                    :inputPlaceholder="item.attrs.placeholder" :doClear="doClearFlag" v-model="formModel[key]">
                  </SubAgentTreeV3>
                  <SubAgentTree1 @select="data => selectTree(key, data)" v-if="item.attrs.treeType === 'agent1'"
                    :inputPlaceholder="item.attrs.placeholder" :doClear="doClearFlag" v-model="formModel[key]"
                    :labelId="labelId">
                  </SubAgentTree1>
                  <AgentSelfTree @select="data => selectTree(key, data)" v-if="item.attrs.treeType === 'agentSelf'"
                    :inputPlaceholder="item.attrs.placeholder" :doClear="doClearFlag"
                    :defaultCheckedAll="item.attrs.defaultCheckedAll" v-model="formModel[key]">
                  </AgentSelfTree>
                  <CounterTree @select="data => selectTree(key, data)" v-if="item.attrs.treeType === 'counter'"
                    :inputPlaceholder="item.attrs.placeholder" :doClear="doClearFlag" v-model="formModel[key]">
                  </CounterTree>
                  <UserAllTree @select="data => selectTree(customContentkey, data)" v-if="item.attrs.treeType === 'userAll'"
                    :inputPlaceholder="item.attrs.placeholder" :doClear="doClearFlag" v-model="formModel[key]">
                  </UserAllTree>
                  <UserNoTree v-if="item.attrs.treeType === 'userNoTree'" :inputPlaceholder="item.attrs.placeholder"
                    :doClear="doClearFlag" v-model="formModel[key]" @change="data => changeUserNoTree(key, data)">
                  </UserNoTree>
                </div>
                <div v-if="item.treeSuffix" class="search-tree-with-suffix__suffix">
                  <slot :name="item.treeSuffix"></slot>
                </div>
              </div>
            </template>
            <template v-if="item.component === 'el-input-number' && item.customContent">
              <Number @change="(value, type) => changeNumber(item.attrs.name, value, type)
                " v-model="formModel[key]" ref="numberInput">
              </Number>
            </template>
            <template v-if="item.component === 'el-cascader' && item.customContent">
              <ProductCascader @changeP="data => changeProduct(item.attrs.name, data)"
                :inputPlaceholder="item.attrs.placeholder" :snFilter="item.attrs.snFilter" ref="cascaderRef">
              </ProductCascader>
            </template>
            <template v-if="item.component === 'el-maintenance-processing' && item.customContent">
              <MaintenanceProcessing @changeP="data => changeProduct(item.attrs.name, data)"
                :inputPlaceholder="item.attrs.placeholder" ref="cascaderRef" />
            </template>
            <template v-if="item.component === 'el-area' && item.customContent">
              <CityCascader @changeP="data => changeProduct(item.attrs.name, data)"
                :inputPlaceholder="item.attrs.placeholder" v-model="formModel[key]" ref="cascaderRef">
              </CityCascader>
            </template>
            <template v-if="item.component === 'el-areas' && item.customContent">
              <CitysCascaderVue @changeP="data => changeProduct(item.attrs.name, data)"
                :inputPlaceholder="item.attrs.placeholder" v-model="formModel[key]" ref="cascaderRef">
              </CitysCascaderVue>
            </template>
            <template v-if="item.component === 'el-street' && item.customContent">
              <CitysCascaderPlus @changeP="data => changeProduct(item.attrs.name, data)"
                :inputPlaceholder="item.attrs.placeholder" v-model="formModel[key]" ref="cascaderRef">
              </CitysCascaderPlus>
            </template>
            <template v-if="
              item.component === 'el-cascader-source' && item.customContent
            ">
              <SourceCascader @changeP="data => changeProduct(item.attrs.name, data)"
                :inputPlaceholder="item.attrs.placeholder" ref="cascaderRef">
              </SourceCascader>
            </template>
            <template v-if="
              item.component == 'el-cascader-stage_grade' &&
              item.customContent
            ">
              <Stage_gradeCascader @changeP="data => changeProduct(item.attrs.name, data)"
                :inputPlaceholder="item.attrs.placeholder" ref="cascaderRef">
              </Stage_gradeCascader>
            </template>
            <template v-if="
                item.component === 'el-cascader-stage_grade_mul' &&
                item.customContent
              ">
                <Stage_gradeCascaderMul @changeP="data => changeProductMul(item.attrs.name, data)"
                  :inputPlaceholder="item.attrs.placeholder" v-model="formModel[key]" ref="cascaderRef">
                </Stage_gradeCascaderMul>
              </template>
            <!-- 故障分类 -->
            <template v-if="item.component === 'el-cascader-fault_classification' && item.customContent">
              <FaultCassificationClasscader ref="cascaderRef" :inputPlaceholder="item.attrs.placeholder"
                @changeP="data => changeProduct(item.attrs.name, data)" />
            </template>
            <!-- 代理商所属区域 -->
            <template v-if="item.component === 'el-provinces'">
              <el-cascader ref="cascaderRef1" :name="item.attrs.name" style="width:100%" :options="areaTreeList"
                :props="{ checkStrictly: true }" @change="val => changeProvinces(item.attrs.name, val)"
                :clearable="clearableFun(item)" :placeholder="$t('app.pleaseSelectAgentRegion')"></el-cascader>
            </template>
            <template v-if="item.component === 'el-provinces-nocheck'">
              <el-cascader ref="cascaderRef1" style="width:100%" :options="areaTreeList"
                :props="{ checkStrictly: false }" @change="val => changeProvinces(item.attrs.name, val)"
                :clearable="clearableFun(item)" :placeholder="$t('app.pleaseSelectAgentRegion')"></el-cascader>
            </template>
            <component size="small" :is="item.component" v-bind="item.attrs" @keyup.enter.native="searchSubmit"
              v-on="item.event" v-model="formModel[key]" :id="item.id" :clearable="clearableFun(item)"
              v-if="!item.customContent" :style="item.style" @remove-tag="multipleRemoveTag" @change="changeValue"
              @clear="inputDoClear(item.component)" :filterable="item.component === 'el-select' ? true : false">
              <template #default v-if="item.component === 'el-select'">
                <template v-if="item.attrs.keyAsValue && item.attrs.linkage">
                  <el-option v-for="option in item.options" :key="Array.isArray(option.key)
                    ? JSON.stringify(option.key)
                    : option.key
                    " :value="option.key" :label="option.value" :multiple="item.attrs.multiple ? item.attrs.multiple : false
                      " :collapse-tags="item.attrs.collapseTags ? item.attrs.collapseTags : false
                        " @click.native="changeAccountType($event, option.key)">
                  </el-option>
                </template>
                <!-- 每个 select 类型的，都绑定一个选择之后进行查询的方法 -->
                <template v-else-if="item.attrs.keyAsValue">
                  <el-option v-for="(option, index) in item.options" :key="index" :value="option.key"
                    :label="option.value" :multiple="item.attrs.multiple ? item.attrs.multiple : false
                      " :collapse-tags="item.attrs.collapseTags ? item.attrs.collapseTags : false">
                  </el-option>
                </template>
                <template v-else>
                  <el-option v-for="(option, index) in item.options" :key="index" :value="option.value"
                    :label="option.value" :multiple="item.attrs.multiple ? item.attrs.multiple : false
                      " :collapse-tags="item.attrs.collapseTags ? item.attrs.collapseTags : false">
                  </el-option>
                </template>
              </template>
              <el-button v-if="item.component === 'el-input' && item.flag === 'trackFlag'" slot="append"
                icon="el-icon-search" @click="tank(item)"></el-button>
              <el-button v-else-if="item.component === 'el-input' && item.flag != 'btnShow'" slot="append"
                icon="el-icon-search" @click="searchSubmit"></el-button>
            </component>
          </el-form-item>
        </el-col>
        <!-- <el-col v-if="searchFormLength === 2" :span="7"></el-col> -->
        <!-- <template v-if="searchFormLength === 1">
          <el-col :span="7"></el-col>
          <el-col :span="7"></el-col>
        </template> -->
        <el-col :xs="6" :sm="6" :md="6" :lg="3" :xl="3"
          style="margin-right:0;padding-left:15px;display: flex;align-items: start;justify-content: center;">
          <div style="height:40px;display: flex;align-items: center;">
            <!-- <template v-if="searchBtnShow">
              <el-button type="text" size="medium" @click="searchSubmit()"
                >{{ $t('app.search') }}</el-button
              >
            </template>
            <el-divider direction="vertical"></el-divider> -->
            <!-- <el-button type="text" size="medium" @click="resetSubmit()"
            >{{ $t('app.clear') }}</el-button
          > -->
            <template v-if="searchBtnShow && !autoSearch">
              <el-button type="primary" round class="button-small" size="medium" @click="searchSubmit()">{{ $t('app.query') }}</el-button>
              <el-divider direction="vertical" v-if="clearBtnShow"></el-divider>
              <span @click="resetSubmit()" class="clear-button" v-if="clearBtnShow">
                <el-tooltip placement="top" :content="$t('app.clearFilter')">
                  <img alt="" class="clearIcon" src="@/assets/images/clear.png" />
                </el-tooltip>
              </span>
            </template>
            <template v-if="exportBtnShow">
              <el-button type="primary" round class="button-small" size="medium" @click="exportClick">{{ $t('app.export') }}</el-button>
            </template>
            <template v-if="searchFormLength > 3 && toggleShow">
              <span class="open-close-btn" @click="toggle">
                <span v-if="expand">{{ $t('app.collapse') }}</span> <span v-else>{{ $t('app.expand') }}</span>
                <i :class="`el-icon-arrow-${expand ? 'up' : 'down'}`"></i>
              </span>
              <el-divider direction="vertical"></el-divider>
            </template>
            <span @click="resetSubmit()" class="clear-button" v-if="clearBtnShow">
              <el-tooltip v-if="searchFormLength > 3 && toggleShow" placement="top" :content="$t('app.clearFilter')">
                <img alt="" class="clearIcon" src="@/assets/images/clear.png" />
              </el-tooltip>
              <el-tooltip v-else-if="!(searchBtnShow && !autoSearch)" placement="top" :content="$t('app.clearFilter')">
                <img alt="" class="clearIcon" src="@/assets/images/clear.png" />
              </el-tooltip>
            </span>
          </div>
        </el-col>
      </el-row>
      <!-- 有展开按钮 -->
      <el-row v-if="searchFormLength > 3 && expand && toggleShow">
        <template v-for="(item, key, index) in searchGroupForm.group2">
          <el-col :xs="18" :sm="12" :md="12" :lg="7" :xl="5" :key="index + key">
            <!-- :span="(index + 1) % 3 === 0 ? 10 : 7" -->
            <el-form-item :prop="key" :class="item.class" :ref="key">
              <template slot="label">
                <div style="display:inline-block;direction: rtl">
                  :
                  {{ (item.label || '').replace(":", "").replace("：", "") }}
                </div>
              </template>
              <template v-if="item.component === 'slot'">
                <slot :name="item.slot"></slot>
              </template>
              <template v-if="item.component === 'el-date-picker' && item.customContent">
                <!-- <el-date-picker
                  v-bind="item.attrs"
                  :start-placeholder="$t('app.startDatePlaceholder')"
                  :end-placeholder="$t('app.endDatePlaceholder')"
                  v-model="formModel[key]"
                  :style="item.style"
                  clearable
                  :editable="false"
                  :type="item.type || ''"
                  :popper-append-to-body="false"
                >
                </el-date-picker> -->
                <DatePicker :item="item" ref="datePicker" v-model="formModel[key]" @change="(beginTime, endTime) =>
                  changeDate(item.attrs.name, beginTime, endTime, key, item)
                  "></DatePicker>
              </template>
              <template v-if="item.component === 'el-tree' && item.customContent">
                <div class="search-tree-with-suffix">
                  <div class="search-tree-with-suffix__main">
                    <IntroduceTree @select="data => selectTree(key, data)" v-if="item.attrs.treeType === 'introduce'"
                      :inputPlaceholder="item.attrs.placeholder" :doClear="doClearFlag" v-model="formModel[key]">
                    </IntroduceTree>
                    <CustomTree @select="data => selectTree(key, data)" v-if="item.attrs.treeType === 'custom'"
                      :inputPlaceholder="item.attrs.placeholder" :doClear="doClearFlag" v-model="formModel[key]">
                    </CustomTree>
                    <UserTree @select="data => selectTree(key, data)" v-if="!item.attrs.treeType"
                      :inputPlaceholder="item.attrs.placeholder" :doClear="doClearFlag" v-model="formModel[key]">
                    </UserTree>
                    <ExtendZtree @select="data => selectTree(key, data)" v-if="item.attrs.treeType === 'extend'"
                      :inputPlaceholder="item.attrs.placeholder" :doClear="doClearFlag" v-model="formModel[key]">
                    </ExtendZtree>
                    <DistributorTree @select="data => selectTree(key, data)" v-if="item.attrs.treeType === 'distributor'"
                      :inputPlaceholder="item.attrs.placeholder" :doClear="doClearFlag" v-model="formModel[key]">
                    </DistributorTree>
                    <GoodsTree @select="data => selectTree(key, data)" v-if="item.attrs.treeType === 'goods'"
                      :inputPlaceholder="item.attrs.placeholder" :doClear="doClearFlag" v-model="formModel[key]">
                    </GoodsTree>
                    <WarehouseTree @select="data => selectTree(key, data)" v-if="item.attrs.treeType === 'warehouse'"
                      :inputPlaceholder="item.attrs.placeholder" :doClear="doClearFlag" v-model="formModel[key]">
                    </WarehouseTree>
                    <!-- 参数名字是啥都行，只需要根据 type 进行判断 -->
                    <SubAgentTree @select="data => selectTree(key, data)" v-if="item.attrs.treeType === 'agent'"
                      :inputPlaceholder="item.attrs.placeholder" :doClear="doClearFlag" v-model="formModel[key]">
                    </SubAgentTree>
                    <SubAgentTree1 @select="data => selectTree(key, data)" v-if="item.attrs.treeType === 'agent1'"
                      :inputPlaceholder="item.attrs.placeholder" :doClear="doClearFlag" v-model="formModel[key]">
                    </SubAgentTree1>
                    <AgentSelfTree @select="data => selectTree(key, data)" v-if="item.attrs.treeType === 'agentSelf'"
                      :inputPlaceholder="item.attrs.placeholder" :doClear="doClearFlag" v-model="formModel[key]"
                      :defaultCheckedAll="item.attrs.defaultCheckedAll">
                    </AgentSelfTree>
                    <CounterTree @select="data => selectTree(key, data)" v-if="item.attrs.treeType === 'counter'"
                      :inputPlaceholder="item.attrs.placeholder" :doClear="doClearFlag" v-model="formModel[key]">
                    </CounterTree>
                    <UserAllTree @select="data => selectTree(key, data)" v-if="item.attrs.treeType === 'userAll'"
                      :inputPlaceholder="item.attrs.placeholder" :doClear="doClearFlag" v-model="formModel[key]">
                    </UserAllTree>
                    <UserNoTree v-if="item.attrs.treeType === 'userNoTree'" :inputPlaceholder="item.attrs.placeholder"
                      :doClear="doClearFlag" v-model="formModel[key]" @change="data => changeUserNoTree(key, data)">
                    </UserNoTree>
                  </div>
                  <div v-if="item.treeSuffix" class="search-tree-with-suffix__suffix">
                    <slot :name="item.treeSuffix"></slot>
                  </div>
                </div>
              </template>
              <template v-if="
                item.component === 'el-input-number' && item.customContent
              ">
                <Number @change="(value, type) => changeNumber(item.attrs.name, value, type)
                  " ref="numberInput" v-model="formModel[key]">
                </Number>
              </template>
              <template v-if="item.component === 'el-cascader' && item.customContent">
                <ProductCascader @changeP="data => changeProduct(item.attrs.name, data)"
                  :inputPlaceholder="item.attrs.placeholder" :snFilter="item.attrs.snFilter" v-model="formModel[key]"
                  ref="cascaderRef">
                </ProductCascader>
              </template>
              <template v-if="item.component === 'el-maintenance-processing' && item.customContent">
                <MaintenanceProcessing @changeP="data => changeProduct(item.attrs.name, data)"
                  :inputPlaceholder="item.attrs.placeholder" ref="cascaderRef" />
              </template>
              <template v-if="item.component === 'el-area' && item.customContent">
                <CityCascader @changeP="data => changeProduct(item.attrs.name, data)"
                  :inputPlaceholder="item.attrs.placeholder" v-model="formModel[key]" ref="cascaderRef">
                </CityCascader>
              </template>
              <template v-if="item.component === 'el-areas' && item.customContent">
                <CitysCascaderVue @changeP="data => changeProduct(item.attrs.name, data)"
                  :inputPlaceholder="item.attrs.placeholder" v-model="formModel[key]" ref="cascaderRef">
                </CitysCascaderVue>
              </template>
              <template v-if="item.component === 'el-street' && item.customContent">
                <CitysCascaderPlus @changeP="data => changeProduct(item.attrs.name, data)"
                  :inputPlaceholder="item.attrs.placeholder" v-model="formModel[key]" ref="cascaderRef">
                </CitysCascaderPlus>
              </template>
              <template v-if="
                item.component === 'el-cascader-source' && item.customContent
              ">
                <SourceCascader @changeP="data => changeProduct(item.attrs.name, data, item)"
                  :inputPlaceholder="item.attrs.placeholder" v-model="formModel[key]" ref="cascaderRef">
                </SourceCascader>
              </template>
              <template v-if="
                item.component === 'el-cascader-stage_grade' &&
                item.customContent
              ">
                <Stage_gradeCascader @changeP="data => changeProduct(item.attrs.name, data, item)"
                  :inputPlaceholder="item.attrs.placeholder" v-model="formModel[key]" ref="cascaderRef">
                </Stage_gradeCascader>
              </template>
              <template v-if="
                item.component === 'el-cascader-stage_grade_mul' &&
                item.customContent
              ">
                <Stage_gradeCascaderMul @changeP="data => changeProductMul(item.attrs.name, data)"
                  :inputPlaceholder="item.attrs.placeholder" v-model="formModel[key]" ref="cascaderRef">
                </Stage_gradeCascaderMul>
              </template>
              <!-- 故障分类 -->
              <template v-if="item.component === 'el-cascader-fault_classification' && item.customContent">
                <FaultCassificationClasscader :inputPlaceholder="item.attrs.placeholder" ref="cascaderRef"
                  @changeP="data => changeProduct(item.attrs.name, data)" />
              </template>
              <!-- 代理商所属区域 -->
              <template v-if="item.component === 'el-provinces'">
                <el-cascader ref="cascaderRef1" style="width:100%" :options="areaTreeList"
                  :props="{ checkStrictly: true }" @change="val => changeProvinces(item.attrs.name, val)"
                  :clearable="clearableFun(item)" :placeholder="$t('app.pleaseSelectAgentRegion')"></el-cascader>
              </template>
              <component size="small" :is="item.component" v-bind="item.attrs" @keyup.enter.native="searchSubmit"
                v-on="item.event" v-model="formModel[key]" :id="item.id" :clearable="clearableFun(item)"
                v-if="!item.customContent" :style="item.style" @remove-tag="multipleRemoveTag" @change="changeValue"
                @clear="inputDoClear(item.component)" :filterable="item.component === 'el-select' ? true : false">
                <template #default v-if="item.component === 'el-select'">
                  <template v-if="item.attrs.keyAsValue && item.attrs.linkage">
                    <el-option v-for="option in item.options" :key="Array.isArray(option.key)
                      ? JSON.stringify(option.key)
                      : option.key
                      " :value="option.key" :label="option.value"
                      @click.native="changeAccountType($event, option.key)">
                    </el-option>
                  </template>
                  <template v-else-if="item.attrs.keyAsValue">
                    <el-option v-for="option in item.options" :key="Array.isArray(option.key)
                      ? JSON.stringify(option.key)
                      : option.key
                      " :value="option.key" :label="option.value">
                    </el-option>
                  </template>
                  <template v-else>
                    <el-option v-for="option in item.options" :key="Array.isArray(option.key)
                      ? JSON.stringify(option.key)
                      : option.key
                      " :value="option.value" :label="option.value">
                    </el-option>
                  </template>
                </template>
                <!-- <template #default v-if="item.component === 'el-input'"> -->
                <el-button v-if="item.component === 'el-input' && item.flag === 'trackFlag'" slot="append"
                  icon="el-icon-search" @click="tank(item)"></el-button>
                <el-button v-else-if="item.component === 'el-input'" slot="append" icon="el-icon-search"
                  @click="searchSubmit"></el-button>
                <!-- </template> -->
              </component>
            </el-form-item>
          </el-col>
        </template>
      </el-row>
      <!-- 没有展开按钮 -->
      <el-row v-if="searchFormLength > 3 && !toggleShow">
        <template v-for="(item, key, index) in searchGroupForm.group2">
          <el-col :xs="18" :sm="12" :md="12" :lg="7" :xl="5" :key="index">
            <!-- :span="(index + 1) % 3 === 0 ? 10 : 7" -->
            <el-form-item :prop="key" :class="item.class">
              <template slot="label">
                <div style="display:inline-block;direction: rtl">
                  :
                  {{ (item.label || '').replace(":", "").replace("：", "") }}
                </div>
              </template>
              <template v-if="item.component === 'slot'">
                <slot :name="item.slot"></slot>
              </template>
              <template v-if="item.component === 'el-date-picker' && item.customContent">
                <!-- <el-date-picker
                  v-bind="item.attrs"
                  :start-placeholder="$t('app.startDatePlaceholder')"
                  :end-placeholder="$t('app.endDatePlaceholder')"
                  v-model="formModel[key]"
                  :style="item.style"
                  clearable
                  :editable="false"
                  :type="item.type || ''"
                  :popper-append-to-body="false"
                >
                </el-date-picker> -->
                <DatePicker :item="item" :propName="key" ref="datePicker" v-model="formModel[key]" @change="(beginTime, endTime) =>
                  changeDate(item.attrs.name, beginTime, endTime, key)
                  "></DatePicker>
              </template>
              <template v-if="item.component === 'el-tree' && item.customContent">
                <div class="search-tree-with-suffix">
                  <div class="search-tree-with-suffix__main">
                    <IntroduceTree @select="data => selectTree(key, data)" v-if="item.attrs.treeType === 'introduce'"
                      :inputPlaceholder="item.attrs.placeholder" :doClear="doClearFlag" v-model="formModel[key]">
                    </IntroduceTree>
                    <CustomTree @select="data => selectTree(key, data)" v-if="item.attrs.treeType === 'custom'"
                      :inputPlaceholder="item.attrs.placeholder" :doClear="doClearFlag" v-model="formModel[key]">
                    </CustomTree>
                    <UserTree @select="data => selectTree(key, data)" v-if="!item.attrs.treeType"
                      :inputPlaceholder="item.attrs.placeholder" :doClear="doClearFlag" v-model="formModel[key]">
                    </UserTree>
                    <ExtendZtree @select="data => selectTree(key, data)" v-if="item.attrs.treeType === 'extend'"
                      :inputPlaceholder="item.attrs.placeholder" :doClear="doClearFlag" v-model="formModel[key]">
                    </ExtendZtree>
                    <DistributorTree @select="data => selectTree(key, data)" v-if="item.attrs.treeType === 'distributor'"
                      :inputPlaceholder="item.attrs.placeholder" :doClear="doClearFlag" v-model="formModel[key]">
                    </DistributorTree>
                    <GoodsTree @select="data => selectTree(key, data)" v-if="item.attrs.treeType === 'goods'"
                      :inputPlaceholder="item.attrs.placeholder" :doClear="doClearFlag" v-model="formModel[key]">
                    </GoodsTree>
                    <WarehouseTree @select="data => selectTree(key, data)" v-if="item.attrs.treeType === 'warehouse'"
                      :inputPlaceholder="item.attrs.placeholder" :doClear="doClearFlag" v-model="formModel[key]">
                    </WarehouseTree>
                    <!-- 参数名字是啥都行，只需要根据 type 进行判断 -->
                    <SubAgentTree @select="data => selectTree(key, data)" v-if="item.attrs.treeType === 'agent'"
                      :inputPlaceholder="item.attrs.placeholder" :doClear="doClearFlag" v-model="formModel[key]">
                    </SubAgentTree>
                    <SubAgentTreeV3 @select="data => selectTree(key, data)" v-if="item.attrs.treeType === 'agentV3'"
                      :inputPlaceholder="item.attrs.placeholder" :doClear="doClearFlag" v-model="formModel[key]">
                    </SubAgentTreeV3>
                    <SubAgentTree1 @select="data => selectTree(key, data)" v-if="item.attrs.treeType === 'agent1'"
                      :inputPlaceholder="item.attrs.placeholder" :doClear="doClearFlag" v-model="formModel[key]">
                    </SubAgentTree1>
                    <AgentSelfTree @select="data => selectTree(key, data)" v-if="item.attrs.treeType === 'agentSelf'"
                      :inputPlaceholder="item.attrs.placeholder" :doClear="doClearFlag" v-model="formModel[key]"
                      :defaultCheckedAll="item.attrs.defaultCheckedAll">
                    </AgentSelfTree>
                    <CounterTree @select="data => selectTree(key, data)" v-if="item.attrs.treeType === 'counter'"
                      :inputPlaceholder="item.attrs.placeholder" :doClear="doClearFlag" v-model="formModel[key]">
                    </CounterTree>
                    <UserAllTree @select="data => selectTree(key, data)" v-if="item.attrs.treeType === 'userAll'"
                      :inputPlaceholder="item.attrs.placeholder" :doClear="doClearFlag" v-model="formModel[key]">
                    </UserAllTree>
                    <UserNoTree @change="data => changeUserNoTree(key, data)" v-if="item.attrs.treeType === 'userNoTree'"
                      :inputPlaceholder="item.attrs.placeholder" :doClear="doClearFlag" v-model="formModel[key]">
                    </UserNoTree>
                  </div>
                  <div v-if="item.treeSuffix" class="search-tree-with-suffix__suffix">
                    <slot :name="item.treeSuffix"></slot>
                  </div>
                </div>
              </template>
              <template v-if="
                item.component === 'el-input-number' && item.customContent
              ">
                <Number @change="(value, type) => changeNumber(item.attrs.name, value, type)
                  " ref="numberInput" v-model="formModel[key]">
                </Number>
              </template>
              <template v-if="item.component === 'el-cascader' && item.customContent">
                <ProductCascader @changeP="data => changeProduct(item.attrs.name, data)"
                  :inputPlaceholder="item.attrs.placeholder" :snFilter="item.attrs.snFilter" v-model="formModel[key]"
                  ref="cascaderRef">
                </ProductCascader>
              </template>
              <template v-if="item.component === 'el-area' && item.customContent">
                <CityCascader @changeP="data => changeProduct(item.attrs.name, data)"
                  :inputPlaceholder="item.attrs.placeholder" v-model="formModel[key]" ref="cascaderRef">
                </CityCascader>
              </template>
              <template v-if="item.component === 'el-areas' && item.customContent">
                <CitysCascaderVue @changeP="data => changeProduct(item.attrs.name, data)"
                  :inputPlaceholder="item.attrs.placeholder" v-model="formModel[key]" ref="cascaderRef">
                </CitysCascaderVue>
              </template>
              <template v-if="item.component === 'el-street' && item.customContent">
                <CitysCascaderPlus @changeP="data => changeProduct(item.attrs.name, data)"
                  :inputPlaceholder="item.attrs.placeholder" v-model="formModel[key]" ref="cascaderRef">
                </CitysCascaderPlus>
              </template>
              <template v-if="
                item.component === 'el-cascader-source' && item.customContent
              ">
                <SourceCascader @changeP="data => changeProduct(item.attrs.name, data)"
                  :inputPlaceholder="item.attrs.placeholder" v-model="formModel[key]" ref="cascaderRef">
                </SourceCascader>
              </template>
              <template v-if="
                item.component === 'el-cascader-stage_grade' &&
                item.customContent
              ">
                <Stage_gradeCascader @changeP="data => changeProduct(item.attrs.name, data)"
                  :inputPlaceholder="item.attrs.placeholder" v-model="formModel[key]" ref="cascaderRef">
                </Stage_gradeCascader>
              </template>
              <template v-if="
                item.component === 'el-cascader-stage_grade_mul' &&
                item.customContent
              ">
                <Stage_gradeCascaderMul @changeP="data => changeProductMul(item.attrs.name, data)"
                  :inputPlaceholder="item.attrs.placeholder" v-model="formModel[key]" ref="cascaderRef">
                </Stage_gradeCascaderMul>
              </template>
              <!-- 代理商所属区域 -->
              <template v-if="item.component === 'el-provinces'">
                <el-cascader ref="cascaderRef1" style="width:100%" :options="areaTreeList"
                  :props="{ checkStrictly: true }" @change="val => changeProvinces(item.attrs.name, val)"
                  :clearable="clearableFun(item)" :placeholder="$t('app.pleaseSelectAgentRegion')"></el-cascader>
              </template>
              <component size="small" :is="item.component" v-bind="item.attrs" @keyup.enter.native="searchSubmit"
                v-on="item.event" v-model="formModel[key]" :id="item.id" :clearable="clearableFun(item)"
                v-if="!item.customContent" :style="item.style" @remove-tag="multipleRemoveTag" @change="changeValue"
                @clear="inputDoClear(item.component)" :filterable="item.component === 'el-select' ? true : false">
                <template #default v-if="item.component === 'el-select'">
                  <template v-if="item.attrs.keyAsValue && item.attrs.linkage">
                    <el-option v-for="option in item.options" :key="Array.isArray(option.key)
                      ? JSON.stringify(option.key)
                      : option.key
                      " :value="option.key" :label="option.value"
                      @click.native="changeAccountType($event, option.key)">
                    </el-option>
                  </template>
                  <template v-else-if="item.attrs.keyAsValue">
                    <el-option v-for="option in item.options" :key="Array.isArray(option.key)
                      ? JSON.stringify(option.key)
                      : option.key
                      " :value="option.key" :label="option.value">
                    </el-option>
                  </template>
                  <template v-else>
                    <el-option v-for="option in item.options" :key="Array.isArray(option.key)
                      ? JSON.stringify(option.key)
                      : option.key
                      " :value="option.value" :label="option.value">
                    </el-option>
                  </template>
                </template>
                <!-- <template #default v-if="item.component === 'el-input'"> -->
                <el-button v-if="item.component === 'el-input'" slot="append" icon="el-icon-search"
                  @click="searchSubmit"></el-button>
                <!-- </template> -->
              </component>
            </el-form-item>
          </el-col>
        </template>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import IntroduceTree from "@/components/search/IntroduceTree.vue";
import CustomTree from "@/components/search/CustomTree.vue";
import UserTree from "@/components/search/UserTree.vue";
import ExtendZtree from "@/components/search/ExtendZtree.vue";
import SubAgentTree from "@/components/search/SubAgentTree.vue";
import SubAgentTreeV3 from "@/components/search/SubAgentTreeV3.vue";
import SubAgentTree1 from "@/components/search/SubAgentTree1.vue";
import AgentSelfTree from "@/components/search/AgentSelfTree_.vue";
import DistributorTree from "@/components/search/DistributorTree.vue";
import GoodsTree from "@/components/search/GoodsTree.vue";
import WarehouseTree from "@/components/search/WarehouseTree.vue";
import CounterTree from "@/components/search/CounterTree.vue";
import UserAllTree from "@/components/search/UserAllTree.vue";
import UserNoTree from "@/components/search/UserNoTree.vue";
import Number from "@/components/search/Number.vue";
import ProductCascader from "@/components/search/ProductCascader.vue";
import MaintenanceProcessing from "@/components/search/MaintenanceProcessing.vue";
import SourceCascader from "@/components/search/SourceCascader.vue";
import Stage_gradeCascader from "@/components/search/Stage_gradeCascader.vue";
import Stage_gradeCascaderMul from "@/components/search/Stage_gradeCascaderMul.vue";
import DatePicker from "@/components/search/DatePicker.vue";
import CitysCascaderVue from "@/components/search/CitysCascader.vue";
import { getDictionaryListI18n, getSubUsers } from "@/api/basicApi";
import { getDictionaryName } from "@/i18n/dictionary";
import { queryPayDetailList } from "@/api/SquirrelSettlement";
import { isEmptyContent } from "@/util/newUtil";
import { deepCopy, trackEvent } from "@/util/util";
import pubsub from "pubsub-js";
import { getCityTreeForRegionfee, queryAccountItemList, queryExpendMethodList } from "@/api/AgentAccount";
import CityCascader from "@/components/search/CityCascader.vue";
import CitysCascaderPlus from "@/components/search/CitysCascaderPlus.vue";
import FaultCassificationClasscader from "@/components/search/FaultClassificationCascader.vue";
import { distribution } from "@/api/ECStudentDetails2";

export default {
  data() {
    return {
      flagSty: false,
      formModel: {},
      searchGroupForm: {},
      searchFormLength: 0,
      expand: false,
      rules: {},
      allDateNames: [],
      doClearFlag: false,
      provinces: [],
      areaTreeList: [],
      canTreeSearch: true
    };
  },
  props: {
    title: {
      type: String,
      default: ""
    },
    searchForm: {
      type: Object,
      default: () => ({})
    },
    inline: {
      type: Boolean,
      default: true
    },
    searchBtnShow: {
      type: Boolean,
      default: true
    },
    exportBtnShow: {
      type: Boolean,
      default: false
    },
    autoSearch: {
      type: Boolean,
      default: true
    },
    clearBtnShow: {
      type: Boolean,
      default: true
    },
    toggleShow: {
      type: Boolean,
      default: true
    },
    labelId: {
      type: Boolean,
      default: false
    },
    isListenClear: {
      type: Boolean,
      default: false
    },
    hasCallBackFormModel: {
      type: Boolean,
      default: false
    },
    doNotSearchWhileClear: {
      type: Boolean,
      default: false
    },
    isLastDate: {
      type: Boolean,
      default: true
    },
    /**
     * 回调处理表单数据
     * @callBackFormModel { Function } formModel 表单数据
     * @formModel { Object } 表单数据
     * 例子： callBackFormModel(formModel) => {return formModel}
     * */
    callBackFormModel: {
      type: Function,
      default: () => null
    }
  },
  methods: {
    getPayDetailOptionLabel(item) {
      const locale = (this.$i18n && this.$i18n.locale) || "zh-CN";
      const name = getDictionaryName("payDetail", item.payDetail, locale);
      return name || (locale === "en-US" ? (item.payDetail || item.payDetailName) : (item.payDetailName || item.payDetail));
    },
    getExpenditureMethodOptionLabel(item) {
      const locale = (this.$i18n && this.$i18n.locale) || "zh-CN";
      const name = getDictionaryName("expenditureMethod", item.methodId, locale);
      return name || item.methodName || String(item.methodId);
    },
    //是否默认展开
    judgeToggle() {
      if (!this.toggleShow) {
        this.expand = true;
      }
    },
    //select改变后重新渲染页面
    ChangeValue() {
      this.$forceUpdate();
    },
    // 当值改变时触发搜索
    changeValue() {
      if (this.autoSearch) {
        this.searchSubmit();
      }
      this.$forceUpdate();
    },
    toggle() {
      this.expand = !this.expand;
      this.$emit("toggleExpand", this.expand);
    },
    resetSubmit() {
      //清除重置时间选择器
      if (this.$refs.datePicker) {
        if (this.$refs.datePicker.length) {
          for (let item of this.$refs.datePicker) {
            item.resetDatePicker();
          }
        }
      }
      //重置数字输入框
      if (this.$refs.numberInput) {
        for (let item of this.$refs.numberInput) {
          item.resetNumberInput();
        }
      }
      //重置联级
      if (this.$refs.cascaderRef) {
        for (let item of this.$refs.cascaderRef) {
          item.resetCascaderInput();
        }
      }
      if (this.$refs.cascaderRef1) {
        for (let item of this.$refs.cascaderRef1) {
          item.handleClear();
          this.changeProvinces(item.$attrs.name, []);
        }
      }
      // this.areaTreeList = []; //重置联级

      this.doClearFlag = !this.doClearFlag; //清除所有的 tree 的选择
      this.$nextTick(() => {
        this.$refs.searchFormRef && this.$refs.searchFormRef.clearValidate();
      })

      const clearableStatus = [] // 获取那些配置想设置了不可清空状态
      for (const key in this.searchForm) {
        clearableStatus.push(this.searchForm[key].attrs?.clearable)
      }
      // 如果存在不可清空状态
      if (clearableStatus.includes(false)) {
        const keys = Object.keys(this.formModel);
        keys.forEach(item => {
          if (this.searchForm[item]?.attrs.clearable !== false) {
            delete this.formModel[item];
          }
        })
        this.$forceUpdate()
      } else {
        // this.$refs.searchFormRef.clearValidate();
        this.$refs.searchFormRef && this.$refs.searchFormRef.resetFields(); //如果设置了默认值，清空不会清空默认的
        // this.$nextTick(()=>{c
        //   this.$refs.searchFormRef.clearValidate();
        // })
        this.formModel = {};
        console.log("@@@@清除数据后的formModel@@@", this.formModel);
      }

      //   this.getProvines();
      //   this.judgeToggle();
      //
      //   this.$emit("refreshComponent");
      //我们再手动清空表单数据，保证页面上的显示为空！
      // this.$emit("search", {});
      // this.$refs.subAgentTreeRef.$emit("clearSelect");
      // console.log(this.$refs.subAgentTreeRef.monitoring);
      // console.log(this.$refs.subAgentTreeRef);
      // this.$refs.userTreeRef.clearSelect();
      if (this.isListenClear) {
        this.$emit("listenClear");
      }
      if (this.autoSearch && !this.doNotSearchWhileClear) {
        this.searchSubmit(undefined, 1);
      }
      this.doNotSearchWhileClear && this.$emit('clearTableData')

      // 防止Search 中包含tree 时 触发两次search
      this.canTreeSearch = false
      setTimeout(() => {
        this.canTreeSearch = true
      }, 500)

    },
    inputDoClear(component) {
      if (component === "el-input") {
        this.searchSubmit();
      } else if (component === "el-select") {
        this.searchSubmit();
        this.$forceUpdate();
      }
    },
    tank(item) {
      console.log(item, 'item');

      trackEvent(item.pointType)
      this.searchSubmit()
    },
    searchSubmit(type, isClear) {
      console.log(this.searchForm, isClear, this.rules, this.searchGroupForm, 'ggggggg');
      // 潜在客户页埋点
      let pointType = this.searchGroupForm?.group1?.followUpData?.pointType || ''
      console.log(this.searchGroupForm?.group1, 'pointType');

      // if(pointType){
      //     trackEvent(pointType)
      // }
      this.$refs.searchFormRef?.validate(valid => {
        if (valid || type === "first") {
          //取消检验
          //第一次不检验，直接放行
          let params = {};
          let deleteList = [];
          for (let key in this.searchGroupForm.group1) {
            //如果有这个 key（有定义就行），我们才需要去判断
            if (
              this.searchGroupForm.group1.hasOwnProperty(key) &&
              this.formModel[key] !== undefined
            ) {
              let obj = this.searchGroupForm.group1[key];
              if (isEmptyContent(this.formModel[key])) {
                //如果是空字符串，数组，对象，或者 null，undefined，那么也要删除这个 key（手动点击清空之后）
                deleteList.push(key);
              }

              //如果我们这个 key 不是其他时间选择器的name 里面的，就可以进行删除
              if (
                obj.component === "el-date-picker" &&
                !this.allDateNames.includes(key)
              ) {
                deleteList.push(key);
              }
              if (
                obj.component === "el-input-number" &&
                !this.allDateNames.includes(key)
              ) {
                deleteList.push(key);
              }
              if (
                obj.component === "el-cascader" &&
                !this.allDateNames.includes(key)
              ) {
                deleteList.push(key);
              }
              if (key === "accountType") {
                console.log(key, 9998, this.formModel);
                if (this.formModel[key] == this.$t('finance.cashAccount')) {
                  this.formModel[key] = 6070001;
                } else if (this.formModel[key] == this.$t('finance.goldAccount')) {
                  this.formModel[key] = 6070003;
                } else if (this.formModel[key] == this.$t('finance.withdrawalAccount')) {
                  this.formModel[key] = 6070004;
                }
              }
              if (key === "payMethod") {
                if (this.formModel[key] == this.$t('finance.bankTransfer')) {
                  this.formModel[key] = "bank_pay";
                }
              }
            }
          }
          for (let key in this.searchGroupForm.group2) {
            //如果有这个 key，我们才需要去判断
            if (
              this.searchGroupForm.group2.hasOwnProperty(key) &&
              this.formModel[key] !== undefined
            ) {
              let obj = this.searchGroupForm.group2[key];
              if (isEmptyContent(this.formModel[key])) {
                //如果是空字符串，数组，对象，或者 null，undefined，那么也要删除这个 key
                deleteList.push(key);
              }
              //如果我们这个 key 不是其他时间选择器的name 里面的，就可以进行删除
              if (
                obj.component === "el-date-picker" &&
                !this.allDateNames.includes(key)
              ) {
                deleteList.push(key);
              }
              if (
                obj.component === "el-input-number" &&
                !this.allDateNames.includes(key)
              ) {
                deleteList.push(key);
              }
              if (
                obj.component === "el-cascader" &&
                !this.allDateNames.includes(key)
              ) {
                deleteList.push(key);
              }
            }
            if (key === "accountType") {
              if (this.formModel[key] == this.$t('finance.cashAccount')) {
                this.formModel[key] = 6070001;
              } else if (this.formModel[key] == this.$t('finance.goldAccount')) {
                this.formModel[key] = 6070003;
              } else if (this.formModel[key] == this.$t('finance.withdrawalAccount')) {
                this.formModel[key] = 6070004;
              }
            }
            if (key === "payMethod") {
              if (this.formModel[key] == this.$t('finance.bankTransfer')) {
                this.formModel[key] = "bank_pay";
              }
            }
          }

          let copyData = { ...this.formModel }; //好处是没有动原来的 formData
          if (deleteList.length > 0) {
            // 删除全部我们不需要的属性（为空的，或者是日期等特殊的 name 的元属性）
            Object.keys(copyData).forEach(function (key) {
              if (deleteList.includes(key)) {
                // console.log(copyData[key]);
                delete copyData[key];
              }
            });
            // delete copyData.beginTime;
          }
          params = { ...copyData, ...params };
          pubsub.publish("initPage2"); //发布消息，让分页组件的 size 和 index 重置！
          this.$emit("search", params, isClear);
        } else {
          this.$message.warning(this.$t('app.pleaseFillRequired'));
          // console.log("字段必填！");
          return false;
        }
      });
    },
    exportClick() {
      this.$emit("exportFile");
    },
    initSearchForm() {
      //构建校验规则，保证字段必填
      Object.keys(this.searchForm).forEach(key => {
        const field = this.searchForm[key] || {};
        const attrs = field.attrs || {};
        let flag = attrs.rule === "required" ? true : false;
        if (flag) {
          let message = attrs.placeholder || this.$t('app.auto_639_4e4da016');
          this.rules[key] = [
            { required: true, message: message, trigger: ["blur", "change"] }
            // { required: true, message: message, trigger: "change" }
          ];

          // }
        }
        //这里的逻辑用于存储所有出现过的时间选择器的 name，避免删除的时候误删
        if (field.component === "el-date-picker") {
          // console.log(this.searchForm[key].attrs.name);
          this.allDateNames = this.allDateNames.concat(attrs.name || []); //concat返回一个新数组
        }
        // 自动设置默认值
        if (attrs.defaultValue !== undefined) {
          this.$set(this.formModel, key, attrs.defaultValue);
        }
      });
      let length = Object.keys(this.searchForm).length;
      this.searchFormLength = length;
      if (length > 3) {
        const entries = Object.entries(this.searchForm);
        const group1 = entries.splice(0, 3);
        const group2 = entries;
        this.searchGroupForm = {
          group1: Object.fromEntries(group1),
          group2: Object.fromEntries(group2)
        };
      } else {
        this.searchGroupForm = {
          group1: this.searchForm,
          group2: null
        };
      }
    },
    selectTree(key, data, item) {
      console.log("选择树", key, data, item);
      if (item?.pointType) {
        trackEvent(item.pointType)
      }
      //不需要通过这里赋值了，因为有v-model绑定
      if (this.autoSearch && this.canTreeSearch) {
        this.searchSubmit();
      }
    },
    changeUserNoTree(key, data, item) {
      console.log('changeUserNoTree', key, data, item);
      if (item?.pointType) {
        trackEvent(item.pointType)
      }
      //不需要通过这里赋值了，因为有v-model绑定
      if (this.autoSearch) {
        this.formModel[key] = data
        this.searchSubmit();
      }
    },
    changeNumber(nameList, value, type) {
      if (type === "start") {
        this.formModel[nameList[0]] = value;
      } else if (type === "end") {
        this.formModel[nameList[1]] = value;
      }
      if (this.autoSearch) {
        this.searchSubmit();
      }
    },
    changeProduct(nameList, dataList, item) {
      if (item?.pointType) {
        trackEvent(item.pointType)
      }
      if (nameList[0]) {
        this.formModel[nameList[0]] = null;
      }
      if (nameList[1]) {
        this.formModel[nameList[1]] = null;
      }
      if (nameList[2]) {
        this.formModel[nameList[2]] = null;
      }
      if (nameList[3]) {
        this.formModel[nameList[3]] = null;
      }
      if (dataList.length === 1) {
        this.formModel[nameList[0]] = dataList[0]; //只有parentId
      } else if (dataList.length === 2) {
        this.formModel[nameList[0]] = dataList[0];
        this.formModel[nameList[1]] = dataList[1];
      } else if (dataList.length === 3) {
        this.formModel[nameList[0]] = dataList[0];
        this.formModel[nameList[1]] = dataList[1];
        this.formModel[nameList[2]] = dataList[2];
      } else if (dataList.length === 4) {
        this.formModel[nameList[0]] = dataList[0];
        this.formModel[nameList[1]] = dataList[1];
        this.formModel[nameList[2]] = dataList[2];
        this.formModel[nameList[3]] = dataList[3];
      }
      if (this.autoSearch) {
        this.searchSubmit();
      }
    },
    changeProductMul(nameList, dataList, item) {
      // 使用 Set 去重并获取唯一值
      const uniqueValues = new Set(dataList.map(item => item[0]));
      this.formModel[nameList[0]] = Array.from(uniqueValues); // 将唯一值转换为数组并赋值给 formModel

      // 过滤掉无效值并赋值给 formModel
      this.formModel[nameList[1]] = dataList.map(item => item[1]).filter(Boolean);

      // 如果启用了自动搜索，则提交搜索
      if (this.autoSearch) {
        this.searchSubmit();
      }
    },
    changeProvinces(nameList, dataList) {
      if (dataList.length === 1) {
        this.formModel[nameList[0]] = dataList[0]; //只有 parentId
        this.formModel[nameList[1]] = null; //必须要清空一下
        this.formModel[nameList[2]] = null; //必须要清空一下
      } else if (dataList.length === 2) {
        this.formModel[nameList[0]] = dataList[0];
        this.formModel[nameList[1]] = dataList[1];
        this.formModel[nameList[2]] = null;
      } else if (dataList.length === 3) {
        this.formModel[nameList[0]] = dataList[0];
        this.formModel[nameList[1]] = dataList[1];
        this.formModel[nameList[2]] = dataList[2];
      } else {
        this.formModel[nameList[0]] = null;
        this.formModel[nameList[1]] = null;
        this.formModel[nameList[2]] = null;
      }
      if (this.autoSearch) {
        this.searchSubmit();
      }
    },
    changeDate(nameList, beginTime, endTime, key, item) {
      console.log("+=====", beginTime, endTime, 'key', key,
        'item', item);
      // 潜在客户埋点
      if (item?.pointType) {
        trackEvent(item.pointType)
      }
      //nextTick后赋值，因为dom中v-model如果有同名属性会覆盖下面赋值
      this.$nextTick(() => {
        if (beginTime === endTime && beginTime != null && endTime != null) {
          this.formModel[nameList[0]] = beginTime;
          this.formModel[nameList[1]] = endTime;
          // this.formModel["month"] = beginTime;
        } else {
          this.formModel[nameList[0]] = beginTime;
          this.formModel[nameList[1]] = endTime;
        }
        if (this.autoSearch) {
          this.searchSubmit();
        }
      });
    },
    //账户类型与充值方式形成二级联动效果
    changeAccountType(event, val) {
      queryPayDetailList({ accountType: val }).then(ret => {
        if (ret.code === 0) {
          const payMethodList = ret.data;
          this.searchForm.payMethod.options = payMethodList.map(e => ({
            key: e.payDetail,
            value: this.getPayDetailOptionLabel(e)
          }));
          this.$set(this.formModel, "payMethod", null);
        }
      });
      if (this.autoSearch) {
        this.searchSubmit();
      }
    },
    //select 选择框的值改变后进行搜索
    changeSelectValue(e) {
      console.log(e, '=====');

      // this.$nextTick(() => {
      if (this.autoSearch) {
        this.searchSubmit();
      }
      // });
    },
    //多选模式下移除 tag
    multipleRemoveTag() {
      if (this.autoSearch) {
        this.searchSubmit();
      }
    },

    initOptions() {
      //遍历所有表单，得到一个 promise 对象的列表
      const promises = Object.keys(this.searchForm).map(key => {
        if (["itemType", "itemTypes"].includes(key)) {
          return queryAccountItemList({}).then(ret => {
            if (ret.code === 0) {
              this.searchForm[key].options = ret.data.map(e => ({
                key: e.itemType,
                value: e.itemName
              }));
            }
          })
        }
        if (["expenditureMethod", "expenditureMethods"].includes(key)) {
          return queryExpendMethodList({}).then(ret => {
            if (ret.code === 0) {
              this.searchForm[key].options = ret.data.map(e => ({
                key: e.methodId,
                value: e.methodName
              }));
            }
          })
        }
        if (["accountType", "accountTypes", "inAccountTypes"].includes(key)) {
          if (this.searchForm[key].attrs.account == "gold") {
            this.$set(this.formModel, key, this.$t('finance.goldAccount'));
          } else if (this.searchForm[key].attrs.account == "cash") {
            this.$set(this.formModel, key, this.$t('finance.withdrawalAccount'));
          } else if (this.searchForm[key].attrs.account == "none") {
          } else {
            this.$set(this.formModel, key, this.$t('finance.cashAccount'));
          }
          return getDictionaryListI18n({ typeId: 6070 }, this.$i18n.locale).then(ret => {
            if (ret.code === 0) {
              const accountTypelist = ret.data;
              this.searchForm[key].options = accountTypelist.map(e => ({
                key: e.id,
                value: e.name
              }));
            }
          });
        }
        if (key === "payMethod") {
          if (this.searchForm[key].attrs.method == "bank") {
            this.$set(this.formModel, key, this.$t('finance.bankTransfer'));
          }
          return queryPayDetailList({ accountType: 6070001 }).then(ret => {
            if (ret.code === 0) {
              const payMethodList = ret.data;
              this.searchForm[key].options = payMethodList.map(e => ({
                key: e.payDetail,
                value: this.getPayDetailOptionLabel(e)
              }));
              // console.log(payMethodLst);
            }
          });
        }
        // if (key === "orderStatusList") {
        //   setTimeout(() => {
        //     console.log(1111)
        //     this.$set(this.formModel, key, "已确认");
        //   }, 2000)
        // }
        if (
          key === "createBy" ||
          key === "confirmUserIds" ||
          key === "operatorUserId"
        ) {
          return getSubUsers({}).then(ret => {
            if (ret.code === 0) {
              const createrList = ret.data;
              this.searchForm[key].options = createrList.map(e => ({
                key: e.userId,
                value: e.userName
              }));
              // console.log(createrList);
            }
          });
        }
      });
      Promise.all(promises).then(() => {
        // 在所有异步操作完成后执行后续代码
        if (this.autoSearch) {
          this.searchSubmit("first"); //先执行一次查询（外面就不用主动调用了）
        }
      });
      /**
       * 调用回调方法，对表单默认值进行处理
       * */
      if (this.hasCallBackFormModel) {
        const formData = this.callBackFormModel(deepCopy(this.formModel || {}))
        this.$set(this, 'formModel', formData)
      }
    },
    // 获取代理商所属区域
    getProvines() {
      if (sessionStorage.getItem("CityTreeForRegionfee")) {
        this.areaTreeList = JSON.parse(
          sessionStorage.getItem("CityTreeForRegionfee")
        );
      } else {
        getCityTreeForRegionfee().then(ret => {
          if (ret.code === 0) {
            let list = ret.data || [];
            list = list.map(item => {
              let obj = {
                label: item.name,
                value: item.code
              };
              obj.children = item.items.map(item1 => {
                let obj = {
                  label: item1.name,
                  value: item1.code
                };
                obj.children = item1.items?.map(item2 => {
                  let obj =
                    {
                      label: item2.name,
                      value: item2.code
                    } || [];
                  return obj;
                });
                return obj;
              });
              return obj;
            });
            this.areaTreeList = list;
            sessionStorage.setItem(
              "CityTreeForRegionfee",
              JSON.stringify(list)
            );
          }
        });
      }
    },
    clearableFun(row) {
      if (row.attrs.clearable === false) return false;
      return true
    }
  },
  mounted() {
    this.initSearchForm();
    this.initOptions();
    this.getProvines();
    this.judgeToggle();
  },
  watch: {
    hasCallBackFormModel(newVal, oldVal) {
      if (newVal) {
        const formData = this.callBackFormModel(deepCopy(this.formModel || {}))
        this.$set(this, 'formModel', formData)
        this.$emit("search", formData);
      }

    },
    "searchForm.partCompletionTime.attrs.rule": {
      handler: function (val) {

        if (val == "w_orderNo") {
          console.log('w_orderNow_orderNo', this.$refs.partCompletionTime);

          delete this.rules["partCompletionTime"]
          this.flagSty = true
          this.$nextTick(() => {
            this.initSearchForm();
          });
        } else {
          console.log('w_orderNow_orderN2222222o');
          this.flagSty = false
          this.$nextTick(() => {
            this.initSearchForm();
          });

        }
      },
      deep: true
    },
    immediate: true
  },
  components: {
    FaultCassificationClasscader,
    IntroduceTree,
    CustomTree,
    UserTree,
    ExtendZtree,
    Number,
    SubAgentTree,
    SubAgentTreeV3,
    SubAgentTree1,
    ProductCascader,
    MaintenanceProcessing,
    DatePicker,
    AgentSelfTree,
    CityCascader,
    SourceCascader,
    CitysCascaderVue,
    CounterTree,
    Stage_gradeCascader,
    Stage_gradeCascaderMul,
    DistributorTree,
    GoodsTree,
    WarehouseTree,
    CitysCascaderPlus,
    UserAllTree,
    UserNoTree
  }
};
</script>

<style lang="scss" scoped>
.search-module {
  display: flex;
  flex-direction: column;

  .search-tree-with-suffix {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    width: 100%;
  }

  .search-tree-with-suffix__main {
    flex: 1;
    min-width: 0;
  }

  .search-tree-with-suffix__suffix {
    flex-shrink: 0;
    margin-left: 6px;
  }

  // border-bottom: 1px solid #ccc;
  .el-row {
    display: flex;
    justify-content: start;
    margin: 0 20px 0 0;
    padding-left: 0;
    width: auto;
    flex-wrap: wrap;

    .el-col {
      min-height: 20px;
    }
  }

  .el-button {
    min-width: 40px;
    width: fit-content;
    height: 35px;
    line-height: 30px;
    padding: 0 10px;
    box-sizing: border-box;
  }

  .search-btn-container {
    justify-content: start;
    margin: 0 20px;

    .el-button {
      width: 70px;
      height: 35px;
      line-height: 30px;
      padding: 0;
    }
  }

  .title-heading {
    font-size: 20px;
    color: #333333;
    font-weight: 500;
    height: 50%;
    line-height: 3.5;
    vertical-align: middle;
  }

  .clear-button {
    // padding: 3px 10px;
    // border-radius: 2px;
    display: inline-block;
    width: 16px;
    height: 16px;
    cursor: pointer;
  }

  .el-divider--vertical {
    margin: 0 12px;
  }

  .open-close-btn {
    // padding-top: 10px;
    // padding-left: 20px;
    color: rgb(74, 131, 232);
    font-size: 14px;
    // font-weight: 500;
    cursor: pointer;
    white-space: nowrap;
  }

  // ::v-deep .el-form-item {
  //   margin-right: 35px;
  // }
}

.el-form-item {
  width: 100%;
  display: flex;
  margin-bottom: 10px;

  // position: relative;
  :deep(.el-form-item__label) {
    // width: 30%;
    white-space: nowrap;
    text-align: right;
    padding-left: 10px;
    min-width: 100px;
    // position: relative; /* 设置文本的定位方式为绝对定位 */
    // right: 0;
    // direction: rtl;
  }

  :deep(.el-form-item__content) {
    flex: 1;
    // height: 32px;
    display: flex;
    align-items: center;

    &>.el-input {
      width: 100%;

      // height: 32px;
      .el-input__inner {
        height: 32px;
      }

      .el-input__suffix {
        //让清空图标垂直居中
        display: flex;
        align-items: center;
      }

      .el-input-group__append:hover .el-icon-search {
        //让搜索按钮鼠标放上去变样子
        color: #4a83e8;
      }
    }

    .el-select {
      width: 100%;

      .el-input {
        .el-input__inner {
          // height: 32px !important;
          min-height: 32px !important;
        }
      }
    }

    .el-date-editor {
      width: 100% !important;
      height: 39px !important;
      padding: 0 5px;
      display: flex;
      align-items: center;

      .el-input__icon {
        height: 20px;
        line-height: 20px;
      }

      .el-range-separator {
        height: 20px;
        line-height: 20px;
        min-width: 18px;
        flex-shrink: 0;
        white-space: nowrap;
      }

      .el-range-input {
        height: 20px;
      }
    }

    .el-cascader {
      width: 100%;

      .el-input__inner {
        height: 32px !important;
      }
    }
  }
}

.clearIcon {
  width: 16px;
}

div.el-select__tags {
  max-width: 250px !important;
}

.refreshDom {
  :deep(.el-form-item__label:before) {
    content: '*';
    color: #6c6ef5 !important;
    margin-right: 4px;
    opacity: 0;
  }

  :deep(.el-input__inner) {
    border-color: #dcdfe6 !important;
  }

  :deep(.el-form-item__error) {
    opacity: 0;
  }
}
</style>
